/**
 * Edit Note Modal Component
 * Wrapper around NoteFormModal for editing existing notes
 */

import React from 'react';
import NoteFormModal from './NoteFormModal';

const EditNoteModal = ({ show, onHide, note, companyId, invoiceId, onSaved }) => {
  return (
    <NoteFormModal
      show={show}
      onHide={onHide}
      companyId={companyId}
      invoiceId={invoiceId}
      note={note}
      onSaved={onSaved}
    />
  );
};

export default EditNoteModal;
